

export default function findIndex(assets, assetIdToFind) {
  return assets.findIndex(({ assetId }) => assetIdToFind === assetId);
}